import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import AuthCallback from "./pages/AuthCallback";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import MemberDashboard from "./pages/MemberDashboard";
import LandlordServices from "./pages/LandlordServices";
import RefurbishmentServices from "./pages/RefurbishmentServices";
import EndOfTenancy from "./pages/EndOfTenancy";
import JoinNetwork from "./pages/JoinNetwork";
import JoinSuccess from "./pages/JoinSuccess";
import LocationPage from "./pages/LocationPage";
import WhatsAppButton from "./components/WhatsAppButton";

// Service pages
import ReactiveMaintenance from "./pages/ReactiveMaintenance";
import PlannedMaintenance from "./pages/PlannedMaintenance";
import HandymanServices from "./pages/HandymanServices";
import CarpentryJoinery from "./pages/CarpentryJoinery";
import PaintingDecorating from "./pages/PaintingDecorating";
import PlasteringRepairs from "./pages/PlasteringRepairs";
import VoidPropertyWorks from "./pages/VoidPropertyWorks";
import LettingAgentMaintenance from "./pages/LettingAgentMaintenance";
import HomeownerServices from "./pages/HomeownerServices";

// Router wrapper to handle auth callback
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (from Google Auth)
  // This handles both / and /dashboard routes with session_id in hash
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/dashboard" element={<MemberDashboard />} />
      <Route path="/my-enquiries" element={<MemberDashboard />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/landlord-services" element={<LandlordServices />} />
      <Route path="/property-refurbishment" element={<RefurbishmentServices />} />
      <Route path="/end-of-tenancy" element={<EndOfTenancy />} />
      <Route path="/join" element={<JoinNetwork />} />
      <Route path="/join/success" element={<JoinSuccess />} />
      {/* Location-specific SEO pages */}
      <Route path="/property-maintenance-manchester" element={<LocationPage location="manchester" />} />
      <Route path="/property-maintenance-stockport" element={<LocationPage location="stockport" />} />
      <Route path="/property-maintenance-cheadle" element={<LocationPage location="cheadle" />} />
      <Route path="/property-maintenance-didsbury" element={<LocationPage location="didsbury" />} />
      <Route path="/property-maintenance-wilmslow" element={<LocationPage location="wilmslow" />} />
      <Route path="/property-maintenance-altrincham" element={<LocationPage location="altrincham" />} />
      <Route path="/property-maintenance-sale" element={<LocationPage location="sale" />} />
      <Route path="/property-maintenance-salford" element={<LocationPage location="salford" />} />
      {/* Service pages */}
      <Route path="/reactive-property-maintenance" element={<ReactiveMaintenance />} />
      <Route path="/planned-property-maintenance" element={<PlannedMaintenance />} />
      <Route path="/handyman-services" element={<HandymanServices />} />
      <Route path="/carpentry-joinery" element={<CarpentryJoinery />} />
      <Route path="/painting-decorating" element={<PaintingDecorating />} />
      <Route path="/plastering-repairs" element={<PlasteringRepairs />} />
      <Route path="/void-property-works" element={<VoidPropertyWorks />} />
      <Route path="/letting-agent-maintenance" element={<LettingAgentMaintenance />} />
      <Route path="/homeowner-services" element={<HomeownerServices />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <WhatsAppButton />
          </BrowserRouter>
        </AuthProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
